import { showToast } from "@base/ui/Toast";
import { ImmersiveVotePage } from "@features/immersive-vote/ui/ImmersiveVotePage";
import { voteDetailQueryOptions } from "@features/votes/api/voteDetailQuery";
import { createFileRoute, isRedirect, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/immersive-votes/")({
  validateSearch: (search): { startVoteId?: number; startVoteSeq?: number } => ({
    startVoteId: search.startVoteId != null ? Number(search.startVoteId) : undefined,
    // 같은 startVoteId를 다시 선택해도 내비게이션이 변화로 인식되게 하는 재선택 토큰
    startVoteSeq: search.startVoteSeq != null ? Number(search.startVoteSeq) : undefined,
  }),
  loaderDeps: ({ search: { startVoteId } }) => ({ startVoteId }),
  loader: async ({ context: { queryClient }, deps: { startVoteId } }) => {
    if (startVoteId != null) {
      try {
        const vote = await queryClient.fetchQuery(voteDetailQueryOptions(String(startVoteId)));
        if (vote.status === "ENDED") {
          showToast.warning("이미 종료된 투표입니다");
          throw redirect({ to: "/votes/$voteId", params: { voteId: String(startVoteId) } });
        }
      } catch (e) {
        if (isRedirect(e)) throw e;
      }
    }
    return null;
  },
  component: ImmersiveVotePage,
});
